<template>
        <div>
        <b-table striped
         small
         hover
         :items="items"
         :fields="fields_data"
         :current-page="currentPage"
         :per-page="perPage"></b-table>
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </div>
</template>

<script>
export default {
  name: 'CasesTable',
  props: ['items'],
  data () {
    return {
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [ 5, 10, 15 ],
      fields_data: [
        {
          label: 'Дата',
          key: 'date_open',
          sortable: true
        },
        {
          label: 'Заявка',
          key: 'ctype',
          sortable: true
        },
        {
          label: 'Описание',
          key: 'chint',
          sortable: true
        }
      ]
    }
  },
  mounted () {
    this.totalRows = this.items_cases.length
  },
  watch: {
    items_cases (newVal, oldVal) {
      this.totalRows = newVal.length
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CasesTable.vue